import React, { ChangeEvent, useState } from 'react';
import {
  Button,
  Surface,
  TitleWithDescription,
  Radio,
  RadioGroup,
} from '@infoods/lifebase-ui';

import classes from './ModeSelector.module.scss';
import { CreationMode } from '../../NgzChallengeCreate.settings';
import { SelectableCard } from '../../../../../shared/components/form-components';
import { ReactComponent as GuidedModeIcon } from '../../../../assets/image/guided-mode.svg';
import { ReactComponent as FreeformModeIcon } from '../../../../assets/image/freeform-mode.svg';

type ModeSelectorProps = {
  onNext: (mode: CreationMode | null) => void;
};

const ModeSelector = ({ onNext }: ModeSelectorProps) => {
  const [selectedMode, setSelectedMode] = useState<CreationMode | null>(null);

  const handleSelectMode = (event: ChangeEvent<HTMLInputElement>, mode: string) => {
    setSelectedMode(mode as CreationMode);
  };

  return (
    <div className={classes.container}>
      <h1 className={classes.pageTitle}>Add a New Challenge</h1>
      <Surface className={classes.box}>
        <TitleWithDescription
          title="Choose How to Create Your Challenge"
          titleFont="title-18-bold"
          description={
            <span>
              Select the creation mode that works best for you —
              <br />
              guided step-by-step or full setup in one screen.
            </span>
          }
          className={classes.title}
        />

        <RadioGroup
          className={classes.radioGroup}
          value={selectedMode}
          onChange={handleSelectMode}
        >
          <SelectableCard variant="inBox" className={classes.card}>
            <Radio value="GUIDED" className={classes.radio} />
            <GuidedModeIcon className={classes.image} />
            <TitleWithDescription
              title="Step-by-Step Guide"
              titleFont="title-16-bold"
              description="***A guided set up is highly recommended if this is your first time creating a challenge."
              descriptionColor="main-black"
              className={classes.description}
            />
          </SelectableCard>
          <SelectableCard variant="inBox" className={classes.card}>
            <Radio value="FREEFORM" className={classes.radio} />
            <FreeformModeIcon className={classes.image} />
            <TitleWithDescription
              title="Free Form Entry"
              titleFont="title-16-bold"
              descriptionColor="main-black"
              className={classes.description}
            />
          </SelectableCard>
        </RadioGroup>
      </Surface>
      <div className={classes.buttonRow}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          disabled={!selectedMode}
          onClick={() => onNext(selectedMode)}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export { ModeSelector };
